import React, { useState, useEffect, useRef } from "react"; // Import useRef
import './EditFollowers.css';
import u from './user.png';
import EditStore from "./EditStore";
import { useNavigate, useOutletContext } from 'react-router-dom'; // Import useNavigate and useOutletContext

function EditFollowers() {
    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1024 }, items: 5 },
        desktop: { breakpoint: { max: 1024, min: 800 }, items: 4 },
        tablet: { breakpoint: { max: 800, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
    };

    const [followers, setFollowers] = useState([]);
    /*const [associatedMembersData, setAssociatedMembersData] = useState([
        { id: 1, category: "Where they live", subcategory: "India", count: 18041 },
        { id: 2, category: "Where they live", subcategory: "Greater Delhi Area", count: 4340 },
        { id: 3, category: "Where they live", subcategory: "Delhi, India", count: 2586 },
        { id: 4, category: "Where they live", subcategory: "New Delhi", count: 2113 },
        { id: 5, category: "Where they studied", subcategory: "Delhi University", count: 332 },
        { id: 6, category: "Where they studied", subcategory: "Indira Gandhi National Open University", count: 103 },
        { id: 7, category: "Where they studied", subcategory: "Amity University", count: 101 },
        { id: 8, category: "Where they studied", subcategory: "Guru Gobind Singh Indraprastha University", count: 86 }
    ]); */
    const [selectedUser, setSelectedUser] = useState(null);
    const [pageId, setPageId] = useState(parseInt(localStorage.getItem('pageId')) || null);
    const navigate = useNavigate();
    const { userId, token, refreshFollowStatus } = useOutletContext(); // Access token from EditStore
    const alertShown = useRef(false);

    // Access the API URL from environment variables
    const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

    useEffect(() => {
        const fetchFollowers = async () => {
            console.log("Fetching followers for pageId:", pageId, " and userId:", userId);

            try {
                const response = await fetch(`${API_URL}/api/get_page_followers?page_id=${pageId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // Include JWT token
                    }
                });

                console.log("Response status:", response.status);

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error("Error response text:", errorText);
                    throw new Error(`HTTP Error: ${response.status} - ${response.statusText} - ${errorText}`);
                }

                const data = await response.json();
                console.log("API response data:", data);

                const formattedFollowers = data.map(follower => ({
                    id: follower.userId,
                    name: follower.username,
                    profilePic: u,
                    isFollowing: follower.isFollowing, // Get isFollowing from API response
                    pageId: parseInt(pageId),
                }));
                setFollowers(formattedFollowers);

            } catch (error) {
                console.error("Error fetching followers:", error);
                if (!alertShown.current) {
                    alert("Failed to fetch followers: " + error.message);
                    alertShown.current = true;
                }
            }
        };

        if (pageId && userId && token) {  // Ensure userId and token are also available
            fetchFollowers();
        }
    }, [pageId, userId, token]); // Include userId and token in the dependency array

    const toggleFollow = async (userId, pageId) => {
        console.log('🔹 Button Clicked: Toggling follow for user:', userId, 'Page ID:', pageId);

        const payload = {
            user_id: userId,
            page_id: pageId,
        };
        console.log("📨 Sending Data to API:", JSON.stringify(payload));

        try {
            const response = await fetch(`${API_URL}/page/unfollow_page_api`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Error response text:", errorText);
                throw new Error(`HTTP Error: ${response.status} - ${response.statusText} - ${errorText}`);
            }

            const result = await response.json();
            console.log('🔹 Response from server:', result);

            alert(result.message);
            setFollowers((prevFollowers) =>
                prevFollowers.map((follower) =>
                    follower.id === userId ? { ...follower, isFollowing: false } : follower
                )
            );
            if (selectedUser && selectedUser.id === userId) {
                setSelectedUser(null);
            }
            refreshFollowStatus()

        } catch (error) {
            console.error("⚠️ Error unfollowing user:", error.message);
            alert("Failed to unfollow: " + error.message);
        }
    };

   /* const handleAdd = (type) => {
        const newItem = prompt(`Add a new ${type}:`);
        if (newItem) {
            const existingEntryIndex = associatedMembersData.findIndex(
                (entry) => entry.subcategory === newItem
            );

            if (existingEntryIndex !== -1) {
                const updatedData = [...associatedMembersData];
                updatedData[existingEntryIndex].count += 1;
                setAssociatedMembersData(updatedData);
            } else {
                const newId = associatedMembersData.length + 1;
                const newEntry = {
                    id: newId,
                    category: type === 'place' ? 'Where they live' : 'Where they studied',
                    subcategory: newItem,
                    count: 1,
                };
                setAssociatedMembersData([...associatedMembersData, newEntry,]);
            }
        }
    }; */

    const handleUserClick = async (user) => {
        try {
            const response = await fetch(`${API_URL}/api/get_user_details?userId=${user.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Include JWT token
                }
            });
            if (!response.ok) {
                throw new Error("Failed to fetch user details");
            }
            const userData = await response.json();
            setSelectedUser(userData);
        } catch (error) {
            console.error("Error fetching user details:", error);
            alert("Failed to fetch user details: " + error.message);
        }
    };

    return (
        <>
            <div className="followlist" responsive={responsive}>
                {/*<div className="associated-members-sections">
                    <div className="associated-members-section" responsive={responsive}>
                        <h2>Where they live <button className="add-btn" onClick={() => handleAdd('place')}>+ Add</button></h2>
                        {associatedMembersData
                            .filter((item) => item.category === "Where they live")
                            .map((item) => (
                                <div key={item.id} className="data-row">
                                    <p>{item.subcategory}</p>
                                    <div className="bar-container">
                                        <div className="bar" style={{ width: `${(item.count / 18041) * 100}%` }}></div>
                                    </div>
                                    <p>{item.count}</p>
                                </div>
                            ))}
                    </div>

                    <div className="associated-members-section" responsive={responsive}>
                        <h2>Where they studied  <button className="add-btn" onClick={() => handleAdd('education')}>+ Add</button></h2>
                        {associatedMembersData
                            .filter((item) => item.category === "Where they studied")
                            .map((item) => (
                                <div key={item.id} className="data-row">
                                    <p>{item.subcategory}</p>
                                    <div className="bar-container">
                                        <div className="bar" style={{ width: `${(item.count / 18041) * 100}%` }}></div>
                                    </div>
                                    <p>{item.count}</p>
                                </div>
                            ))}
                    </div>
                </div>*/}

                <div className="followers">
                    <ul>
                        {followers.map((follower) => (
                            follower.isFollowing ? (  // Conditionally render based on isFollowing
                                <li key={follower.id} className="follower-item">
                                    <img src={follower.profilePic} alt="Profile" onClick={() => handleUserClick(follower)} style={{ cursor: 'pointer' , borderRadius:'40px'}} width={'40px'} height={'40px'}/>
                                    <span onClick={() => handleUserClick(follower)} style={{ cursor: 'pointer' }}>{follower.name}</span>
                                    <button onClick={() => toggleFollow(follower.id, pageId)}>Remove</button>
                                </li>
                            ) : null // Don't render the list item if not following
                        ))}
                    </ul>
                </div>
            </div>

            {/* Display user information when a user is selected */}
            {selectedUser && (
                <div className="user-info">
                    <h2>User Information</h2>
                    <p>Name: {selectedUser.username}</p> {/* Display username */}
                    <p>ID: {selectedUser.userId}</p> {/* Display userId */}
                    {/* Add more user details here as needed */}
                </div>
            )}
        </>
    );
}

export default EditFollowers;